function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M11.014.559a2 2 0 011.972 0l4.234 2.4 4.195 2.466a2 2 0 01.986 1.709L22.44 12l-.039 4.866a2 2 0 01-.986 1.709L17.22 21.04l-4.234 2.4a2 2 0 01-1.972 0l-4.234-2.4-4.195-2.466a2 2 0 01-.986-1.709L1.56 12l.039-4.866a2 2 0 01.986-1.709L6.78 2.96l4.234-2.4z",
  fill: "#fff"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M14.566 12.625l.328-1.81h-2.047V9.641c0-.495.286-.978 1.203-.978h.93v-1.54S14.136 7 13.328 7c-1.686 0-2.788.867-2.788 2.436v1.38H8.666v1.809h1.874V17h2.307v-4.375h1.72z",
  fill: "#1976D2"
});

function SvgSocialFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none"
  }, props), _ref, _ref2);
}

export default SvgSocialFacebook;